// Preload critical routes for better UX
export const preloadRoute = (routeName: string) => {
  switch (routeName) {
    case 'services':
      return import('../pages/Services')
    case 'about':
      return import('../pages/About')
    case 'contact':
      return import('../pages/Contact')
    // case 'news': // Hidden for now
    //   return import('../pages/News')
    case 'careers':
      return import('../pages/Careers')
    default:
      return Promise.resolve()
  }
}

// Preload critical routes after initial page load
export const preloadCriticalRoutes = () => {
  // Wait for initial load to complete
  if (typeof window !== 'undefined') {
    window.addEventListener('load', () => {
      // Delay preloading to not interfere with initial page load
      setTimeout(() => {
        preloadRoute('services')
        preloadRoute('about')
        preloadRoute('contact')
      }, 2000)
    })
  }
}

// Preload route on hover for instant navigation
export const preloadOnHover = (routeName: string) => {
  let preloadTimer: NodeJS.Timeout
  
  const handleMouseEnter = () => {
    preloadTimer = setTimeout(() => {
      preloadRoute(routeName)
    }, 100) // Small delay to avoid unnecessary preloads
  }
  
  const handleMouseLeave = () => {
    if (preloadTimer) {
      clearTimeout(preloadTimer)
    }
  }
  
  return { handleMouseEnter, handleMouseLeave }
}